import { CrmService, ReferenceDataService } from '@/services';

export default {
  getChatUrl: async ({ commit }) => {
    const response = await ReferenceDataService.getChatUrl();
    commit('setChatUrl', response.chatUrl);
  },
  getCrmTemplates: ({ commit, getters }) => {
    if (!getters.getCrmTemplate()) {
      CrmService.getCrmTemplates().then(response => {
        commit('setCrmTemplates', response.data);
      });
    }
  }
};
